<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M15.623 3.36955C15.623 2.88931 15.2336 2.5 14.7534 2.5H7.14496C6.66472 2.5 6.27541 2.88931 6.27541 3.36955V9.16654H8.83031V4.98205H15.623V3.36955ZM5.04933 9.99972C4.34741 10.0283 3.34978 9.99972 2.5 9.1664V19.4478C2.5 21.1304 3.93767 22.4995 5.65347 22.4995H20.719C21.6795 22.4995 22.4581 21.7209 22.4581 20.7604V18.8375H19.3462C17.6304 18.8375 16.2342 17.4683 16.2342 15.7857C16.2342 14.1032 17.6304 12.734 19.3462 12.734H22.4581V11.7388C22.4581 10.7783 21.6795 9.99972 20.719 9.99972H5.04933ZM19.3465 17.6169H22.5V13.9549H19.3465C18.317 13.9549 17.4793 14.7763 17.4793 15.7859C17.4793 16.7955 18.317 17.6169 19.3465 17.6169ZM19.9803 15.1755H19.9562C19.6191 15.1755 19.3458 15.4488 19.3458 15.7859C19.3458 16.123 19.6191 16.3962 19.9562 16.3962H19.9803C20.3174 16.3962 20.5906 16.123 20.5906 15.7859C20.5906 15.4488 20.3174 15.1755 19.9803 15.1755ZM17.7758 6.2028C18.2561 6.2028 18.6454 6.59211 18.6454 7.07235V9.16662H10.1476V6.2028H17.7758ZM5.03107 9.03139V5.36934H4.40868C3.37751 5.36934 2.5 6.18917 2.5 7.20036C2.5 8.21156 3.37751 9.03139 4.40868 9.03139H5.03107Z" 
                :fill="color"
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgWallet',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>